


export var config = {

	utcoffset: "+0100",
	testLocations: ['localhost','test'],
	startTime: Date.now(),
	intervalUpdateTimeLogicS: 10,
	intervalReloadContentsMin: 30,
	limitedCountryCodes: ["CN","IR","KP","CU","ID","SY","SD"],
	faRulerSymbol: 'fa fa-wifi',

	slidefolder: "/slides/2023/AE091EGS",

	passwordHash: "18dbba863822820e07e5712764f5b198",
	passwordCookieExpirationDays: 30,

	currentScheduleItemLinksTo: "#about",

	gotoStartButtonTime: "05.03.2023, 9:00:00",
}
